import 'primevue/resources/themes/saga-blue/theme.css';       // theme
import 'primevue/resources/primevue.min.css';                 // core css
import 'primeicons/primeicons.css';                           // icons
import 'primeflex/primeflex.css';                             // optional
import {createApp} from 'vue';
import App from './App.vue';
import router from './router';

import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import Tooltip from 'primevue/tooltip';
import store from "@/store";

import Stepper from 'primevue/stepper';
import StepperPanel from 'primevue/stepperpanel';
import Steps from 'primevue/steps';
import Button from "primevue/button";
import IconField from "primevue/iconfield";
import InputIcon from "primevue/inputicon";
import InputText from "primevue/inputtext";
import TextArea from "primevue/textarea";
import {createPinia} from "pinia";


const app = createApp(App);
const pinia = createPinia();
app.use(PrimeVue);
app.use(ToastService);
app.use(store)
app.use(pinia);
app.directive('tooltip', Tooltip);

// eslint-disable-next-line vue/multi-word-component-names
app.component('Stepper', Stepper);
// eslint-disable-next-line vue/multi-word-component-names
app.component('StepperPanel', StepperPanel);
// eslint-disable-next-line vue/multi-word-component-names
app.component('Steps', Steps);
// eslint-disable-next-line vue/multi-word-component-names
app.component('Button', Button);
// eslint-disable-next-line vue/multi-word-component-names
app.component('IconField', IconField);
// eslint-disable-next-line vue/multi-word-component-names
app.component('InputIcon', InputIcon);
// eslint-disable-next-line vue/multi-word-component-names
app.component('InputText', InputText);
// eslint-disable-next-line vue/multi-word-component-names
app.component('TextArea', TextArea);


//app.component('PrimeSteps', PrimeSteps);
app.use(router);

// Initialize Firebase auth before mounting
store.dispatch('initAuth').then(() => {
    app.mount('#app');
});
